import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from '../global.service';
import { HttpClient } from '@angular/common/http';
import * as M from "materialize-css/dist/js/materialize";
import * as $ from 'jquery';
import { Router, ActivatedRoute } from '@angular/router';
import { UnosStatusComponent } from '../unos-status/unos-status.component';

@Component({
	selector: 'app-home-krediti',
	templateUrl: './home-krediti.component.html',
	styleUrls: ['./home-krediti.component.css']
})
export class  HomeKreditiComponent  implements OnInit {
	loading : boolean = false; 
	currentView = 'main';
	kategorije : any = [];
	idTipaPrijave : any = null;
	prijave : any = [];
	novaPrijavaKredit : boolean = true; 
	odabraniKreditId : any = null;
	prekoPortala = false;
	odabranaPrijavaKredit : any = null;
	prijavakreditponisti : any = null;
	prijavakreditobradi : any = null;
	sortOption = 1; //dozvoljene vrijednosti su bodovi i vrijeme
	modalInstance : any = null;
	jedinice : any = [];
	statusi : any = [];
	filterIme : any = '';
	filterPrezime : any = '';
	filterDatum : any = '';
	filterBrzh : any = '';
	tekstMaila : any = '';

	constructor(public globalSrvc: GlobalService, public http : HttpClient, private route: ActivatedRoute, public router: Router) { }

	ngOnInit() {
		setTimeout(() => {
			/*var elems = document.querySelectorAll('.modal');
    		var instances = M.Modal.init(elems, {});*/
		}, 1000);
		this.ucitajKandidate();
	}

	logout(){
		this.globalSrvc.logout();
		this.globalSrvc.redirectToLogin();
	}

	rList : any = null;

	ucitajKandidate(){
		this.loading = true; 
		this.sortOption = 1;

		this.http.get(this.globalSrvc.rootUrl + 'prijave/krediti/admin/ranglista')
		.subscribe(data => {
			if (data){
				this.rList = data;
				this.prijave = this.rList.kandidati;
				//console.log(this.prijave);
				this.initTooltips();
			}
			this.loading = false;
		},
		error => {
			this.loading = false;
		});
	}

	dodajPrijavuKredit(){
		this.novaPrijavaKredit = true;
		this.odabraniKreditId = null;
		this.prekoPortala = false;
		this.currentView = 'kredit';
		//this.router.navigate(["prijavaPage"]);
	}

	onInsertKredit(data){
		this.currentView = 'main';
		var elem = document.getElementById('modal10');				
		var instance = M.Modal.init(elem, {onCloseEnd : () => {this.ucitajKandidate();}});
		instance.open();
	}

	onInsertSendMail(data){
		this.currentView = 'main';
		var elem = document.getElementById('modalmailText');				
		var instance = M.Modal.init(elem, {onCloseEnd : () => {}});
		instance.open();
	}


	pregled(prijava){
		this.novaPrijavaKredit = false;
		this.odabraniKreditId = prijava.id;
		this.currentView = 'kredit';
		this.prekoPortala = prijava.prekoPortala; 
	}

	ponistiprijavu(prijava){
		this.prijavakreditponisti = prijava; 
		this.currentView = 'main';
		var elem = document.getElementById('modal7');				
		var instance = M.Modal.init(elem, {onCloseEnd : () => {}});
		instance.open();
	}

	obradiprijavu(prijava){
		this.prijavakreditobradi = prijava; 
		this.currentView = 'main';
		var elem = document.getElementById('modal9');				
		var instance = M.Modal.init(elem, {onCloseEnd : () => {}});
		instance.open();
	}
	
	server_data : any; 

	ucitajJedinice() {	
		this.statusi = [{id : 5, naziv : 'Odobren'}, {id : 6, naziv : 'Odbijen'}];
		this.openUnosStatusModal();
	}

	openUnosStatusModal(){
		var elem = document.getElementById('modalStatusKredit');					
		this.modalInstance = M.Modal.init(elem, {onCloseEnd : () => {console.log('destroy'); this.modalInstance.destroy();}});
		this.modalInstance.open();
		//this.modalRef.ucitaj();
	}

	onInsertStatus(event){
		this.ucitajKandidate();
		if (this.modalInstance)
			this.modalInstance.destroy();
	
		this.initTooltips();
	}

	onCancel(data){
		this.currentView = 'main';
		this.initTooltips();
	}

	initTooltips(){
		setTimeout(() => {
			let elems = document.querySelectorAll('.tooltipped');
            let instances = M.Tooltip.init(elems, {});    
		}, 500);
	}

	msg : any = null;

	ponistiPrijavuKreditPotvrda(){
		let url = 'prijave/admin/krediti/ponisti';

		this.loading = true;

		setTimeout(() => {				
		
			this.http.post(url, this.prijavakreditponisti)
				.subscribe(data => {
					this.msg = data;
					this.loading = false;

					if (this.msg.id == 1) {
						this.ucitajKandidate();
					}
					else {
						//this.globalSrvc.showErrorModal(this.msg.text);
						M.toast({html:this.msg.text, displayLength : 4000});
					}
				}
				, error => {
					this.loading = false;
					//this.globalSrvc.showGenericErrorModal();
				}
			);
		}, 500);
	}

	posaljimail(){
		let url = 'prijave/krediti/sendmail';

		this.loading = true;

		setTimeout(() => {				
		
			this.http.post(url, {text : this.tekstMaila?this.tekstMaila:''})
				.subscribe(data => {
					this.msg = data;
					this.loading = false;

					if (this.msg.id == 1) {
						//this.ucitajKandidate();
						M.toast({html:'Mailovi su uspješno poslati', displayLength : 4000});
					}
					else {
						//this.globalSrvc.showErrorModal(this.msg.text);
						M.toast({html:this.msg.text, displayLength : 4000});
					}
				}
				, error => {
					this.loading = false;
					//this.globalSrvc.showGenericErrorModal();
				}
			);
		}, 500);
	}

	promijeniSort(){
		if (this.sortOption == 1){
			//sortirano po vremenu, sortiraj po imenima
			this.prijave.sort( (a, b) => {	
				if (a.prezime>b.prezime) return 1;
				if (a.prezime<b.prezime) return -1;
				if (a.ime>b.ime) return -1;
				if (a.ime<b.ime) return 1;
				return -1;
			});
			this.sortOption = 2;
			//console.log(this.prijave);
		}
		else {
			this.prijave.sort( (a, b) => a.datumPrijaveStr<b.datumPrijaveStr?1:-1);
			this.sortOption = 1;
		}
	}

	getNazivDugmetaSort(){
		return this.sortOption==1?'Sortiraj po imenima':'Sortiraj po vremenu';
	}

	ranglistaPDF(outType){
        let url = 'getReport/krediti/ranglista';
        
		this.loading = true;
        this.http.get(url, {params : {'outType' : outType}, responseType: 'blob'})
        .subscribe(
         data => {            
            this.loading = false;
            this.globalSrvc.openBlob(data, outType);
         },
         error => {            
            this.loading = false;
            window.alert('Došlo je do greške prilikom generisanja rang liste');
        });    
    }

	openhelp(){
		
        let url = 'upustvo';
        this.http.get(url, {params : {}, responseType: 'blob'})
        .subscribe(
         data => {            
            this.loading = false;
            this.globalSrvc.openBlob(data, 'pdf');
         },
         error => {            
            this.loading = false;
            window.alert('Došlo je do greške prilikom fajla');
        });   
	}
}
